import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=83d50052&scoped=true&"
import script from "./Positions.vue?vue&type=script&lang=ts&"
export * from "./Positions.vue?vue&type=script&lang=ts&"
import style0 from "./Positions.vue?vue&type=style&index=0&id=83d50052&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d50052",
  null
  
)

export default component.exports